import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setPasswordRecoveryPending } from '../utils/passwordRecoveryPending';
import {
    getAuthCallbackError,
    hasEmailConfirmationCallback,
    hasRecoveryCallbackParams,
} from '../utils/recoverySession';

/**
 * Supabase may redirect auth links to Site URL (/) or /login instead of the intended path.
 * Forward recovery vs email-confirmation callbacks to the correct route.
 */
export function RecoveryCallbackRedirect() {
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const suffix = `${location.search}${location.hash}`;
        const onResetRoute =
            location.pathname === '/reset-password' || location.pathname === '/password-reset';
        const onLoginRoute = location.pathname === '/login';

        const authError = getAuthCallbackError();
        const isRecovery = hasRecoveryCallbackParams();
        const isEmailConfirm = hasEmailConfirmationCallback();

        if (!isRecovery && !isEmailConfirm && !authError) return;

        if (isRecovery) {
            setPasswordRecoveryPending();
            if (!onResetRoute) {
                navigate(`/reset-password${suffix}`, { replace: true });
            }
            return;
        }

        if (isEmailConfirm || authError) {
            if (!onLoginRoute && !onResetRoute) {
                navigate(`/login${suffix}`, { replace: true });
            }
        }
    }, [location.pathname, location.search, location.hash, navigate]);

    return null;
}
